import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getAuditReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportAuditReport } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class AuditReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `AuditReportBeginDate`);
        this.props.formInput(date, `AuditReportEndDate`);
        if (localStorage.getItem("AuditReportBranchIds") != null) {
            this.props.formInput(localStorage.getItem("AuditReportBranchIds").split(","), "AuditReportBranchIds")
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
            localStorage.setItem("AuditReportBranchIds", this.props.selectedBranchIds)
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.auditReport && newProps.auditReport.length > 0 ? newProps.auditReport[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    cleanSearch = () => {
        this.props.clearFormInput(`AuditReportBeginDate`);
        this.props.clearFormInput(`AuditReportEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds.join(",");

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/auditReport?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branchIds}`, "auditReport");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds ? this.props.selectedBranchIds.join(",") : "";
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getAuditReport({ beginDate, endDate, branchIds, pageNumber, pageSize });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    render() {
        return (
            <Grid headerContent={reportAuditReport}>
                <PageHeader title={LOOKUP.report.AuditReport.text} 
                    description={LOOKUP.report.AuditReport.description}
                />
                <Header
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    branchOptions={this.props.branchOptions}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.auditReport &&
                    <CardSimple>
                        <Body
                            auditReport={this.props.auditReport}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        branchOptions: branchOptions,
        auditReport: state.reports.auditReport,
        loggedBranch: state.common.branchId,
        beginDate: state.form.AuditReportBeginDate,
        endDate: state.form.AuditReportEndDate,
        selectedBranchIds: state.form.AuditReportBranchIds
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAuditReport: model => dispatch(getAuditReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AuditReport));